// extracted by mini-css-extract-plugin
export default {"header":"header__SF5f_Q_G"};